import { styled } from '@mui/material'

export const Divider = styled('div')(({ theme }) => ({
  background: theme.palette.surface[200],
  height: '1px',
  width: '100%',
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(1.5),
  [theme.breakpoints.up('md')]: {
    width: '205px',
  },
}))

export const MostReadContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}))
